import MuiLinearProgress, { LinearProgressProps as MuiProps } from '@material-ui/core/LinearProgress';
export type LinearProgressProps = MuiProps;

export default MuiLinearProgress;
